import { type UserEntity, UserType } from "@/shared/types/user.entity";

/**
 * INTERNAL staff always; a member while their organization has the card wallet. A backend that predates the
 * opt-in omits the field, and every organization had the wallet then.
 */
export function canUseCardWallet(user: UserEntity | null | undefined): boolean {
  if (!user) return false;
  return user.user_type === UserType.INTERNAL || user.organization?.card_wallet_enabled !== false;
}
